import { render } from "./settings-policies.vue?vue&type=template&id=6252a3be&scoped=true"
import script from "./settings-policies.vue?vue&type=script&lang=js"
export * from "./settings-policies.vue?vue&type=script&lang=js"

import "./settings-policies.vue?vue&type=style&index=0&id=6252a3be&scoped=true&lang=css"
import "./settings-policies.vue?vue&type=style&index=1&id=6252a3be&lang=scss&scoped=true"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6252a3be"]])

export default __exports__